module.exports = __webpack_public_path__ + "img/P150T_weapon_119.9b3261b2.png";